module.exports = __webpack_public_path__ + "img/submit_success.2cd8e4d2.png";